"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LogisticsNetworkRoles;
(function (LogisticsNetworkRoles) {
    LogisticsNetworkRoles["LogisticsNetworkAdmin"] = "Logistics Network Admin";
    LogisticsNetworkRoles["LogisticsNetworkReader"] = "Logistics Network Reader";
})(LogisticsNetworkRoles = exports.LogisticsNetworkRoles || (exports.LogisticsNetworkRoles = {}));
//# sourceMappingURL=logistics-network.js.map